import merge from 'lodash/merge';
import {twMerge} from '../../../common/twMerge';
import {MOBILE_HEADER_HEIGHT_PX} from '../../../header/constants';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {NavibarProps} from './NavibarProps.interface';

/**
 * 네비바 : https://www.figma.com/file/lun1D9CzpkoufkINaOHID1/NEXT_Design_System?node-id=4925-37237&t=6IBsQyITwLOkoSAv-4
 */
export function Navibar({
  title,
  onClickBack,
  className,
  style,
  useStaticIcon = false,
  ...props
}: NavibarProps) {
  return (
    <div
      className={twMerge(
        'relative flex w-full items-center bg-theme-bg-base px-10pxr',
        className
      )}
      style={merge(
        {
          height: `${MOBILE_HEADER_HEIGHT_PX}px`,
        },
        style
      )}
      {...props}
    >
      {/* Header 좌측 영역입니다. */}
      <div className="flex shrink-0 items-center">
        <Icon
          type={
            useStaticIcon
              ? IconType.NavigationBackStatic
              : IconType.NavigationBack
          }
          onClick={onClickBack}
        />
      </div>
      {/* Header 중앙 영역입니다. */}
      <div className="flex flex-1 items-center justify-center px-12pxr">
        <Text className="font-medium2-bold text-theme-solid-100 line-clamp-1">
          {title}
        </Text>
      </div>
    </div>
  );
}
